var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 9.53674e-05H0V10H14.9997V9.53674e-05Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43734 7.62939e-06H6.56237V4.06241H0V5.93737H6.56237V9.99977H8.43734V5.93737H14.9997V4.06241H8.43734V7.62939e-06Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5364 6.73898L14.9996 8.66304V6.73898H11.5364Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13013 6.73898L14.9996 9.99977V9.0777L10.7899 6.73898H9.13013Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4362 9.99977L9.13013 7.60732V9.99977H13.4362Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13037 6.73898L14.9998 9.99977V9.0777L10.7902 6.73898H9.13037Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13037 6.73898L14.9998 9.99977V9.0777L10.7902 6.73898H9.13037Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64666 6.73892L0 8.2093V6.73892H2.64666Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86949 7.15358V9.99974H0.746826L5.86949 7.15358Z",
    fill: "#0052B4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20967 6.73898L0 9.0777V9.99977L5.86946 6.73898H4.20967Z",
    fill: "#D80027"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46326 3.2608L0 1.33674V3.2608H3.46326Z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86946 3.2608L0 7.62939e-06V0.922079L4.20967 3.2608H5.86946Z",
    fill: "#0052B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56348 7.62939e-06L5.86951 2.39246V7.62939e-06H1.56348Z",
    fill: "#0052B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86946 3.2608L0 7.62939e-06V0.922079L4.20967 3.2608H5.86946Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86946 3.2608L0 7.62939e-06V0.922079L4.20967 3.2608H5.86946Z",
    fill: "#D80027"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.353 3.26086L14.9997 1.79048V3.26086H12.353Z",
    fill: "#0052B4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13037 2.8462V3.8147e-05H14.253L9.13037 2.8462Z",
    fill: "#0052B4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7902 3.2608L14.9998 0.922079V7.62939e-06L9.13037 3.2608H10.7902Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag_en.c23a4599472c01bb17e2a716ff25a2ca.svg";
export { ForwardRef as ReactComponent };